<section class="w-full h-full flex flex-col items-center justify-center bg-transparent overflow-hidden">
  <div class="select-none overflow-hidden">
      <div class="text-center mt-20">
        <h1 class="mb-4 text-7xl tracking-tight font-bold lg:text-9xl text-gray-200">404</h1>
          <p class="mb-4 text-lg font-light text-gray-400">Whoops! That page doesn’t exist.</p>
          <p *ngIf="authService.is_logged_in()" class="mb-6 text-sm text-gray-500">
            This panel is for admins. If you're a member, log out and access your scanner directly.
          </p>
          <button *ngIf="authService.is_logged_in()"
                  (click)="on_logout()"
                  class="dark-btn-primary px-6 py-2">
            Log out
          </button>
      </div>
  </div>
</section>
